import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full px-2" }
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, null, -1)

import { useUserStore } from '@/store/users';
import { computed, onBeforeUnmount, ref, toRefs, watch } from 'vue';
import Scorecards from '@/views/Accounts/Scorecards.vue';
import Statistics from '@/views/Accounts/Statistics.vue';
import Preferences from '@/views/Accounts/Preferences.vue';
import { Tabs, Tab } from 'vue3-tabs-component';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();

const route = useRoute();

const { user } = toRefs(route.params);

const viewedUser = computed(() => userStore.secureUser || userStore.viewUser);

const sectionTabs = ref<InstanceType<typeof Tabs>>(null);

watch(() => route.name, initialise, { immediate: true });

function unmount() {
  userStore.secureUser = null;
  userStore.viewUser = null;
}

async function initialise() {
  unmount();
  if (user && route.name !== 'Account') {
    await userStore.getUserAccount(user.value.toString());
  } else {
    await userStore.getSecureUser();
    const params = new URL(window.location.toString().replace('/#', ''))
      .searchParams;
    if (params.get('twitter_email') === '1' && sectionTabs.value) {
      sectionTabs.value.selectTab('#preferences');
    }
  }
}

onBeforeUnmount(unmount);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(viewedUser))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(viewedUser).Name), 1),
          _createVNode(_unref(Tabs), {
            ref: (_value, _refs) => {
              _refs['sectionTabs'] = _value
              sectionTabs.value = _value
            },
            options: { useUrlFragment: false },
            "nav-class": "flex px-2 mb-2",
            "nav-item-class": "w-32 uppercase hover:text-primary text-md",
            "nav-item-active-class": "border-b-2 border-primary text-primary",
            "nav-item-link-class": "block py-3 mr-8"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Tab), { name: "Scorecards" }, {
                default: _withCtx(() => [
                  _createVNode(Scorecards)
                ]),
                _: 1
              }),
              _createVNode(_unref(Tab), { name: "Statistics" }, {
                default: _withCtx(() => [
                  _createVNode(Statistics)
                ]),
                _: 1
              }),
              (!_unref(user))
                ? (_openBlock(), _createBlock(_unref(Tab), {
                    key: 0,
                    name: "Preferences"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Preferences)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 512),
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})